import { Module, VuexModule, MutationAction, getModule, Action, Mutation } from "vuex-module-decorators"
import { ExportVideoIds, ExportVideoParams, ExportVideo } from '../../interfaces/export'
import * as api from '@/store/api';
import Store from "../index"

@Module({
  dynamic: true,
  store: Store,
  name: "exports",
  namespaced: true
})
class VideoExporter extends VuexModule {
  videos: ExportVideo[] = []

  get listVideos() {
    return this.videos
  }

  @Mutation
  addVideo(newVideo: ExportVideo) {
    this.videos.push(newVideo)
  }

  @Mutation
  deleteVideo(uuid: string) {
    this.videos = this.videos.filter((video: ExportVideo) => video.id !== uuid)
  }

  @MutationAction({ mutate: ['videos'] })
  async getVideos(payload: ExportVideoIds) {
    return { videos: await api.fetchExportVideos(payload) }
  }

  @Action({ commit: 'addVideo' })
  async createVideo(payload: ExportVideoParams) {
    return await api.createExportVideo(payload)
  }

  @Action
  async removeVideo(uuid: string) {
    const status = await api.deleteExportVideo(uuid)
    status == 204 && this.context.commit('deleteVideo', uuid)
  }
}

export default getModule(VideoExporter)